import { gql } from "@apollo/client";

export const ORDERS_QUERY = gql`
  query Orders {
    orders {
      id
      pickup_type
      service_preference
      customer_id
      staff_id
      order_no
      bag_no
      delivery_date
      garment_details
      amount
      received_date
      locker_date
      location
      status
      promo_code
      customer {
        id
        first_name
        last_name
        email
      }
      staff {
        id
        first_name
        last_name
        email
      }
    }
  }
`;

export const ORDER_QUERY = gql`
  query Order($id: ID!) {
    order(id: $id) {
      id
      pickup_type
      service_preference
      customer_id
      staff_id
      order_no
      bag_no
      delivery_date
      garment_details
      amount
      received_date
      locker_date
      location
      status
      promo_code
      customer {
        id
        first_name
        last_name
        email
      }
      staff {
        id
        first_name
        last_name
        email
      }
    }
  }
`;

export const CUSTOMER_ORDERS_QUERY = gql`
  query CustomerOrders($status: String!) {
    customerOrders(status: $status) {
      id
      pickup_type
      service_preference
      customer_id
      staff_id
      order_no
      bag_no
      delivery_date
      garment_details
      amount
      received_date
      locker_date
      location
      promo_code
      status
    }
  }
`;

export const CREATE_ORDER_MUTATION = gql`
  mutation CreateOrder(
    $pickupType: PickType!
    $servicePreference: String!
    $orderNo: String!
    $bagNo: String!
    $garmentDetails: String!
    $promoCode: String
    $receivedDate: String!
    $lockerDate: String!
    $deliveryDate: String!
    $location: String!
  ) {
    createOrder(
      pickup_type: $pickupType
      service_preference: $servicePreference
      order_no: $orderNo
      bag_no: $bagNo
      garment_details: $garmentDetails
      promo_code: $promoCode
      received_date: $receivedDate
      locker_date: $lockerDate
      delivery_date: $deliveryDate
      location: $location
    ) {
      id
      pickup_type
      service_preference
      customer_id
      order_no
      bag_no
      delivery_date
      garment_details
      amount
      received_date
      locker_date
      location
      status
    }
  }
`;

export const CHECK_PROMO_CODE_QUERY = gql`
  query CheckPromoCode($code: String!) {
    checkPromoCode(code: $code) {
      code
      discount
      discount_type
    }
  }
`;
